/**
 * Modal component stubs for web platform
 * Replaces react-native-modal with simple web components
 */
import React from 'react';

export const Modal = (props: any) => {
  const { visible = false, children, ...rest } = props;
  
  if (!visible) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      {...rest}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: 8,
          padding: 16,
          maxWidth: '90%',
          maxHeight: '90%',
          overflow: 'auto',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
